module.exports = __webpack_public_path__ + "media/images/wedding/thumb/28-c4320d8520c0370b1026573876e43332.jpg";